const FieldMaxLengths = Object.freeze({
    PHONE: 15,
    NAME: 100,
    PREFIX: 20,
    MIDDLE_NAME: 60,
    SUFFIX: 20,
});

export default FieldMaxLengths;
